export default __webpack_public_path__ + "static/media/My_car_website_images-9_10.5448b6ad.jpg";